import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { isEmpty } from 'lodash';
import { Icon } from '../..';
import { useFormGroupExplian as useFormGroupExplain } from './FormGroupExplain.hooks';
import { FormGroupExplainRoot } from './FormGroupExplain.styled';
// Component.
// -----------------------------------------------------------------------------
export const FormGroupExplain = ({ children, role }) => {
    // Hooks.
    // ---------------------------------------------------------------------------
    const { cssClass, icon } = useFormGroupExplain(role);
    // Render.
    // ---------------------------------------------------------------------------
    return (_jsxs(FormGroupExplainRoot, { role: "alert", children: [!isEmpty(icon) && _jsx(Icon, { className: cssClass, icon: icon }), _jsx("div", { children: children })] }));
};
//# sourceMappingURL=FormGroupExplain.js.map